module.exports = __webpack_public_path__ + "f5ca040a924c47656568235693dcddb9.pdf";